export enum enumDeliveryOrderType {
  FULL = 0,
  PARTIAL = 1,
}
